// extracted by mini-css-extract-plugin
export var alt = "PartnershipBrands-module--alt--dc4a9";
export var desktopOnly = "PartnershipBrands-module--desktopOnly--5cc52";
export var main = "PartnershipBrands-module--main--1d63e";
export var mobileOnly = "PartnershipBrands-module--mobileOnly--3bf51";
export var styledLogo = "PartnershipBrands-module--styledLogo--60205";
export var subTitle = "PartnershipBrands-module--subTitle--b6ffc";
export var textLeft = "PartnershipBrands-module--textLeft--638eb";
export var title = "PartnershipBrands-module--title--98bcb";
export var visuallyHidden = "PartnershipBrands-module--visuallyHidden--8c586";